import { render, staticRenderFns } from "./CreateWalkthroughModal.vue?vue&type=template&id=16f629f8&"
import script from "./CreateWalkthroughModal.vue?vue&type=script&lang=ts&"
export * from "./CreateWalkthroughModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1339545384/src/github.com/trainn-tech/trainn-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16f629f8')) {
      api.createRecord('16f629f8', component.options)
    } else {
      api.reload('16f629f8', component.options)
    }
    module.hot.accept("./CreateWalkthroughModal.vue?vue&type=template&id=16f629f8&", function () {
      api.rerender('16f629f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/components/modals/CreateWalkthroughModal.vue"
export default component.exports